export const environment = {
  env: 'production',
  production: true,
  appApi: 'https://pregnantwithdiabetes.vercel.app/api/app',
  release: '650f0ce837eb792d87a2d64c2a30c59e281cbbb6',
  dist: 'web',
  environment: 'production',
};
